const STORAGE_PREFIX = 'misoft_chat';

/**
 * Ключ в localStorage для кода диалога (уникальный на пару tokenCode + домен).
 */
function getCodeStorageKey(tokenCode) {
  return `${STORAGE_PREFIX}_code_${tokenCode || 'default'}`;
}

/**
 * Генерирует уникальный код клиента (UUID v4-подобный).
 */
function generateCode() {
  const hex = '0123456789abcdef';
  let result = '';
  for (let i = 0; i < 36; i++) {
    if (i === 8 || i === 13 || i === 18 || i === 23) {
      result += '-';
    } else if (i === 14) {
      result += '4';
    } else {
      result += hex[Math.floor(Math.random() * 16)];
    }
  }
  return result;
}

/**
 * Возвращает существующий код диалога из localStorage или создаёт, сохраняет и возвращает новый.
 * @param {string} tokenCode - Код токена канала (при добавлении виджета).
 * @returns {string} Уникальный код диалога (клиента).
 */
export function getOrCreateDialogCode(tokenCode) {
  const key = getCodeStorageKey(tokenCode);
  try {
    let code = typeof localStorage !== 'undefined' ? localStorage.getItem(key) : null;
    if (!code) {
      code = generateCode();
      localStorage.setItem(key, code);
    }
    return code;
  } catch (e) {
    return generateCode();
  }
}
